
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.78 2.907c.428.2.778.561.947 1.033.17.472.127.967-.079 1.385l.704.33a2.511 2.511 0 00.114-1.966A2.588 2.588 0 009.12 2.22l-.34.687zm.594-1.203c.743.35 1.35.975 1.643 1.795a3.07 3.07 0 01-.138 2.405l.722.34c.446-.907.539-1.98.172-3.003A3.946 3.946 0 009.724 1l-.349.704zM3.908 7.802L2.738 4.66l-1.62.576A1.655 1.655 0 00.104 7.374c.323.868 1.301 1.317 2.184 1.003l1.62-.575zm-3.16-.656a.991.991 0 01.603-1.281l.976-.347.703 1.885-.976.346a1.03 1.03 0 01-1.306-.603zM6.657 1.49L9 7.772c-1.91-.392-3.37-.4-4.448-.199l-.236-.633c1.03-.21 2.248-.22 3.634-.029L6.42 2.808c-.938 1.024-1.862 1.764-2.803 2.257l-.236-.633c.946-.514 2.04-1.406 3.276-2.943zM5.43 9.92a1.149 1.149 0 01-.545-.389l-.818-1.07-1.978.703 1.301 1.63a.557.557 0 00.62.174l1.436-.51a.284.284 0 00.19-.268.282.282 0 00-.194-.265L5.43 9.92zm-1.56.386l-.668-.83.622-.221.65.836-.604.215z","fill":"#1C2F45"}})])
          )
        }
      }
    